import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ServicesSection from "./components/ServicesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="font-sans bg-white min-w-[1024px]">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <HowItWorksSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/5511999999999?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20agendar%20uma%20consulta!"
        target="_blank"
        rel="nofollow noreferrer"
        aria-label="Falar no WhatsApp"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-secondary hover:bg-secondary-500 text-white rounded-full shadow-lg transition-all cursor-pointer"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </main>
  );
}
